import React from 'react';

import InherentLogo from './logo/logo-inherent.png';

const LogoFull = () => {
  return <img src={InherentLogo} alt="Logo inherent" style={{width: 'auto', height: 30}} />;
};

export default LogoFull;
